<template>
	<Transition name="fade">
		<div 
			v-if="modalVisible" 
			class="fixed inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-999"
			@click="close"
		>
			<div class="relative w-full max-w-2xl bg-white shadow-lg rounded-lg p-8 text-black max-h-full overflow-y-auto flex justify-center">
				<button
		        aria-label="close"
		        class="absolute top-0 right-0 text-xl text-gray-500 py-0 px-1" 
		        @click="close"
		      >
		        ×
		      </button>
				<slot />
			</div>
		</div>
	</transition>
</template>

<script>
export default {
  data(){
	    return {
	        modalVisible : false
	    }
	},
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector('body').classList.add('overflow-hidden');
      }
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  },
  methods: {
  	show(index){
        this.modalVisible = true
    },
    close(){
        this.modalVisible = false
    },
  },
};
</script>